import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'POSTCHAIN/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetPostChains(client, { payload: { resolve, reject, ...restPayload } }) {
  try {
    const response = yield client.post('/postChain/list',
    {
      data: {
        ...restPayload
      }
    });
    yield put(actions.loadSuccess(response.result.postChains));
    resolve && resolve(response.result.postChains);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
